import { setFormErrors } from "./error";
import { getLocalStorageItem, setLocalStorageItem } from "./localStorageHelper";
import axios from "./axios";
import { SurveyRoutes, pageTitles } from "config/Consts";

const getPageTitles = (location: string): string => {
  if (location.includes(SurveyRoutes.personality))
    return pageTitles.personality;
  else if (location.includes(SurveyRoutes.elgiblity))
    return pageTitles.eligibility;
  else if (location.includes(SurveyRoutes.followUp1))
    return pageTitles.FolllowUp1;
  else if (location.includes(SurveyRoutes.followUp2))
    return pageTitles.FollowUp2;
  else if (location.includes(SurveyRoutes.followUp3))
    return pageTitles.FollowUp3;
  else if (location.includes("jobs/search")) return pageTitles.JobSearch;
  else if (location.includes("jobs/saved")) return pageTitles.SavedJob;
  else if (location.includes("jobs/applied")) return pageTitles.AppliedJob;
  else if (location.includes("/about")) return pageTitles.About;
  return pageTitles.home;
};

export {
  setFormErrors,
  getLocalStorageItem,
  setLocalStorageItem,
  axios,
  getPageTitles,
};
